module.exports = __webpack_public_path__ + "static/chunks/src/page-home/part-window-view-slider/assets/slider-image-02.eaa28840bdb63cc4c75b07b98bbb58ca.webp";